import styled from "styled-components";

export const SurveyFrecuency = styled.div`
  overflow: auto;
  height: 100%;
  padding-bottom: 40px;
  box-sizing: border-box;
  display: flex;
  .title {
    color: #3E3DA3;
    font-family: "Nunito Sans Bold";
    font-size: 16px;    
  }
  .doseage-inputs {
    width: 100%;
    margin-top: 38px;
    .input-toogle {
      display: flex;
      align-items: center;
      &__text {
        color: #526479;
        font-family: "Nunito Sans";
        font-size: 16px;
        margin-right: 10px;
      }
    }
    .input-space {
      max-width: 400px;
      position: relative;
      margin-top: 30px;
      .input-label {
        color: #3E3E5B;
        font-family: "Nunito Sans";
        font-size: 14px;
        margin-bottom: 10px;
      }
      .input-msg {
        color: #8C8DA4;
        font-family: "Nunito Sans";
        font-size: 14px;
        padding: 10px;
      }
      &__number-icon{
        position: absolute;
        z-index: 1;
        right: 0;
        margin: 20px 26px 20px 0;
        color: #878792;
        font-size: 15px;
      }
    }
  }
`

export const SurveyRange = styled.div`
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow: auto;
  height: 100%;
  padding-bottom: 40px;
  box-sizing: border-box;
  width: 100%;
  .title {
    color: #3E3DA3;
    font-family: Nunito Sans;
    font-size: 18px;
    margin-top: 10px;
  }
  .calendar-inputs {
    margin: 20px auto 28px;
    display: flex;
    justify-content: space-between;
    max-width: 400px;
    .input-container {
      display: flex;
      align-items: center;
      &__box {
        width: 140px;
      }
      .input-label {
        margin-right: 10px;
        color: #3E3E5B;
        font-family: "Nunito Sans";
        font-size: 16px;
      }
      &--unfocus {
        opacity: 0.3  ;
      }
    }
  }
  .calendar-range-container {
    display: flex;
    .calendar-range {
      margin: auto;
      width: 300px;
    }
  }
  .toogle-container {
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-family: "Nunito Sans Light";
      font-size: 15px;
      color: #526479;
      margin-right: 10px;
    }
  }
`